export default class EmailPromptController {
  constructor($scope, submitEmail, close) {
    this.$scope = $scope;
    this.submitEmail = submitEmail;
    this.close = close;
  }

  submit() {
    return Promise.resolve().then(() => {
      this.submitEmail(this.email);
      this.close();
    });
  }
}